module.exports = __webpack_public_path__ + "static/media/adrian_griggs.1e284647.png";